module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.88932dad.ttf";